import { LivesettlementsWidget, ViewController } from "@gaming/srvg-classes-core";

// uses srvg.eventExchange

export class LiveSettlementsViewController extends ViewController {
    public name: string;
    livesettlementWidget: LivesettlementsWidget;

    constructor(options) {
        options = options || {};
        super( options );

        this.name = 'LiveSettlementsViewController';
        this.livesettlementWidget = options.livesettlementWidget || {};
    }

    handleGuiSwitchEvent(event, provider) {
        this.livesettlementWidget.setHeight();
    }


}